import type { Component, ParentComponent } from "solid-js";
import { Container } from "@/components/shared/Container";
import { RootLayout } from "@/domains/auth/routes/layout";
import { LoadingSkeleton } from "../ui/skeleton";

export const DetailLayout: ParentComponent = (props) => {
  return <RootLayout>{props.children}</RootLayout>;
};

export const SkeletonDetailLayout: Component = () => {
  return (
    <RootLayout>
      <div class="min-h-screen bg-gray-50">
        <Container size="6xl" class="py-4 pt-24 md:pt-28 space-y-4">
          {/* Back button */}
          <LoadingSkeleton width={80} height={20} class="rounded mb-2" />

          {/* Card 1 – entity header (company / freelancer info) */}
          <LoadingSkeleton class="w-full rounded-xl h-36 md:h-44" />

          {/* Card 2 – main content (proposal detail / job description) */}
          <LoadingSkeleton class="w-full rounded-xl h-64 md:h-80" />

          {/* Card 3 – secondary content (skills / competencies) */}
          <LoadingSkeleton class="w-full rounded-xl h-36 md:h-48" />
        </Container>
      </div>
    </RootLayout>
  );
};
